import { Component } from 'react';
import { StaticValues } from '../../../../../../../../insfrastructure/services/static_values';
import { listCities } from '../../../../../../../../insfrastructure/services/cities';
import { emptyField, ErrorMessage, errorsLength, formatErrors, validateCEP } from '../../../../../../../../insfrastructure/utils/form-validators';
import { retrievePostcodeInfo } from '../../../../../../../../insfrastructure/services/cep';
import { Input } from '../../../../../../../components/input';
import CheckboxInput from '../../../../../../../components/checkbox';
import { Select } from '../../../../../../../components/select';
import ResponseModal from '../../../../../../../components/response-modal';
import companySegmentIcon from '../../../../../../../../assets/icons/company_segment.png';
import emailIcon from '../../../../../../../../assets/icons/email.png'
import linkIcon from '../../../../../../../../assets/icons/link.png';
import locationIcon from '../../../../../../../../assets/icons/location.png';
import phoneIcon from '../../../../../../../../assets/icons/phone.png';
import './styles.sass';

export class CompanyData extends Component<{form_data: Record<string, any>, onSubmit: (form: Record<string, any>) => void}> {
    state: any = {
      form: this.props.form_data,
      formErrors: {},
      cityOptions: [],
      segmentOptions: []
    }
    timeout: any = null
  
    componentDidMount() {
      this.getStaticValues();
    }
  
    getStaticValues = async () => {
        try {  
          setTimeout(() => {
            const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;          
            const segmentOptions = Object.keys(staticValues.segment).map((key: any) => ({ value: key, label: staticValues.segment[key] }));
            
            this.setState({ segmentOptions });
          }, 1000);
        } catch (error) {}
    }
  
    onCityNameChange = async (e: any) => {
      const cityOptions = (await listCities(e)).map(x => ({ value: x.id, label: x.name }));
  
      this.setState({ cityOptions });
  
      return cityOptions;
    }
  
    onCEPChange = async (value: any) => {
      clearTimeout(this.timeout);
      
      this.timeout = setTimeout(async () => {
        let street = '';
        let neighborhood = '';
        let city_id = '';
        let city = '';
        let uf = '';
        let result = null;
  
        if(validateCEP(value) === '') {
          try {
            result = await retrievePostcodeInfo(value);
          } catch (error) {
            this.setState({
              responseData: {
                type: 'error',
                title: 'CEP Inválido',
                text: ''
              }
            });
  
            return;
          };
  
          const cityOptions = await this.onCityNameChange(result.localidade);
  
          street = result.logradouro;
          neighborhood = result.bairro;
          city_id = result.city_id + '';        
          city = cityOptions.filter(x => x.value === city_id)[0].label;
          uf = result.uf;
        };
    
        this.setState({
          form: {
            ...this.state.form,
            street,
            neighborhood,
            city_id,
            city,
            uf,
            address: street+','+neighborhood+','+city+','+uf
          }
        });
      }, 1000);
    }
  
    onSubmit = () => {
      if (this.state.loading) return;

      let errors_validators: Record<string, any[]> = {
        fantasy_name: [emptyField(this.state.form.fantasy_name, 'string')],
        // terms_and_conditions: [emptyField(this.state.form.terms_and_conditions, 'string')],
        postcode: [emptyField(this.state.form.postcode, 'string')],
        address_number: [emptyField(this.state.form.address_number, 'string')],
        cnpj: [emptyField(this.state.form.cnpj, 'string')],
        segment_id: [emptyField(this.state.form.segment_id, 'string')],
        company_email: [emptyField(this.state.form.company_email, 'string')], 
        phone: [emptyField(this.state.form.phone, 'string')],
        // website: [validateRegex(this.state.form.website, /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/, 'URL inválida')],
        // facebook_link: [validateRegex(this.state.form.facebook_link, /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/, 'URL inválida')],
        // instagram_link: [validateRegex(this.state.form.instagram_link, /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/, 'URL inválida')],
        // linkedin_link: [validateRegex(this.state.form.linkedin_link, /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/, 'URL inválida')],
        // google_link: [validateRegex(this.state.form.google_link, /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/, 'URL inválida')]
      };

      if (!this.state.form.ie_free) {
        errors_validators['ie'] = [emptyField(this.state.form.ie, 'string')];
      };

      const errors = formatErrors(errors_validators);

      this.setState({ formErrors: errors });
  
      if(errorsLength(errors) > 0) return;
  
      try {
        setTimeout(() => {
          this.setState({ sended: true });
          this.props.onSubmit(this.state.form);
        });
      } catch (error) {
        this.setState({ loading: false });
      }
    }
  
    render() {
      return (
        <div className='form company-data'>
          <div className='form-container'>
            <div className='columns'>
              <div className='column'>
                <Input
                name='fantasy_name'
                label='Nome Fantasia'
                value={this.state.form.fantasy_name}
                onChange={e => this.setState({ form: { ...this.state.form, fantasy_name: e } })}/>
                <ErrorMessage errors={this.state.formErrors['fantasy_name']} />
                <div className='row'>
                  <div className='flex-1'>
                    <Input
                    name='ie'
                    label='IE Empresa'
                    mask='99999999999999'
                    value={this.state.form.ie}
                    disabled={this.state.form.ie_free}
                    onChange={e => this.setState({ form: { ...this.state.form, ie: e, ie_free: false } })}/>
                    <ErrorMessage errors={this.state.formErrors['ie']} />
                  </div>
                  <CheckboxInput
                  name='ie_free'
                  label='Isento'
                  checked={this.state.form.ie_free}
                  onChange={e => this.setState({ form: { ...this.state.form, ie_free: e, ie: e ? '' : this.state.form.ie } })}/>
                </div>
                <div className='location row'>
                  <img src={locationIcon} alt='location' />
                  <p>Localização</p>
                </div>
                <div className='block'>
                    <Input
                    name='postcode'
                    label='CEP da empresa'
                    mask='99999-999'
                    value={this.state.form.postcode}
                    onChange={e => {this.setState({ form: { ...this.state.form, postcode: e } }); this.onCEPChange(e)}} />
                    <ErrorMessage errors={this.state.formErrors['postcode']} />
                    <div className='address-part'>
                      <p>Rua: <p>{ this.state.form.street ? this.state.form.street : '-' }</p></p>
                    </div>
                    <div className='address-part'>
                      <p>Bairro: <p>{ this.state.form.neighborhood ? this.state.form.neighborhood : '-' }</p></p>
                    </div>
                    <div className='address-part'>
                      <p>Cidade / UF: <p>{ this.state.form.city ? this.state.form.city+' / '+this.state.form.uf : '-' }</p></p>
                    </div>
                    <div className='row address-row'>
                      <div className='street-number-input-container'>
                        <Input
                        name='address_number'
                        label='N°'
                        type='number'
                        value={this.state.form.address_number}
                        onChange={e => this.setState({ form: { ...this.state.form, address_number: e } })}/>
                        <ErrorMessage errors={this.state.formErrors['address_number']} />
                      </div>
                      <div className='flex-1'>
                        <Input
                        name='address_complement'
                        label='Complemento'
                        value={this.state.form.address_complement}
                        onChange={e => this.setState({ form: { ...this.state.form, address_complement: e } })}/>
                        <ErrorMessage errors={this.state.formErrors['address_complement']} />
                      </div>
                    </div>
                </div>
              </div>
              <div className='column'>
                <Input
                name='cnpj'
                label='CNPJ da Empresa'
                mask='99.999.999/9999-99'
                value={this.state.form.cnpj}
                onChange={e => this.setState({ form: { ...this.state.form, cnpj: e } })}/>
                <ErrorMessage errors={this.state.formErrors['cnpj']} />
                <Select
                name='segment_id'
                label='Segmento da empresa'
                icon={companySegmentIcon}
                options={this.state.segmentOptions}
                value={this.state.form.segment_id}
                onChange={e => this.setState({ form: { ...this.state.form, segment_id: e } })}/>
                <ErrorMessage errors={this.state.formErrors['segment_id']} />
                <Input
                name='company_email'
                label='E-mail'
                icon={emailIcon}
                value={this.state.form.company_email}
                onChange={e => this.setState({ form: { ...this.state.form, company_email: e } })}/>
                <ErrorMessage errors={this.state.formErrors['company_email']} />
                <Input
                name='phone'
                mask='(99) 99999-9999'
                icon={phoneIcon}
                type='number'
                label='Telefone para contato'
                value={this.state.form.phone}
                onChange={e => this.setState({ form: { ...this.state.form, phone: e } })}/>
                <ErrorMessage errors={this.state.formErrors['phone']} />
                <Input
                name='website'
                icon={linkIcon}
                label='Site da empresa'
                value={this.state.form.website}
                onChange={e => this.setState({ form: { ...this.state.form, website: e } })}/>
                <ErrorMessage errors={this.state.formErrors['website']} />
                <Input
                name='facebook_link'
                icon={linkIcon}
                label='Facebook'
                value={this.state.form.facebook_link}
                onChange={e => this.setState({ form: { ...this.state.form, facebook_link: e } })}/>
                <ErrorMessage errors={this.state.formErrors['facebook_link']} />
                <Input
                name='instagram_link'
                icon={linkIcon}
                label='Instagram'
                value={this.state.form.instagram_link}
                onChange={e => this.setState({ form: { ...this.state.form, instagram_link: e } })}/>
                <ErrorMessage errors={this.state.formErrors['instagram_link']} />
                <Input
                name='linkedin_link'
                icon={linkIcon}
                label='Linkedin'
                value={this.state.form.linkedin_link}
                onChange={e => this.setState({ form: { ...this.state.form, linkedin_link: e } })}/>
                <ErrorMessage errors={this.state.formErrors['linkedin_link']} />
                <Input
                name='google_link'
                icon={linkIcon}
                label='Google'
                value={this.state.form.google_link}
                onChange={e => this.setState({ form: { ...this.state.form, google_link: e } })}/>
                <ErrorMessage errors={this.state.formErrors['google_link']} />
              </div>
            </div>
            <button className='primary submit' onClick={this.onSubmit}>Confirmar</button>
          </div>
          <ResponseModal
          render={this.state.responseData}
          type={this.state.responseData?.type}
          title={this.state.responseData?.title}
          text={this.state.responseData?.text}
          onClose={() => this.setState({ responseData: null })} />
        </div>
      )
    }
}